import { usePromptLibrary } from '.';
import { PromptFormDialog } from '../PromptFormDialog';
export function EditPrompt() {
    const { setView, setCurrentPromptID, currentPrompt } = usePromptLibrary();
    const handleCloseFormDialog = () => {
        setCurrentPromptID(undefined);
        setView('library');
    };
    return <PromptFormDialog onClose={handleCloseFormDialog} initialValues={currentPrompt}/>;
}
